<template>
    <div class="loading-component">
        <div class="loading-component__logo">
            <img :src="img" alt="loading.png">
        </div>
        <div class="loading-component__svg">
            <svg  width="70px" height="70px" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M38.3716 24.4954C39.0329 24.7409 39.6649 25.0874 40.1792 25.4917C40.7817 25.9681 41.252 26.5601 41.5606 27.2531C41.9427 28.1339 42.0015 29.1012 41.8545 30.0253C41.8251 30.3141 41.7369 30.6028 41.59 30.8627C41.443 31.1226 41.252 31.3536 41.0169 31.5558L40.7964 31.7435L40.7817 31.7146C40.3996 31.9745 39.9588 32.1333 39.5032 32.191C39.0476 32.2488 38.5627 32.2199 38.1218 32.0755C37.6809 31.9312 37.2988 31.6713 37.0343 31.2959C36.7551 30.8916 36.6669 30.4296 36.711 29.9531C36.7257 29.7654 36.7845 29.5921 36.858 29.4333C37.049 29.0291 37.387 28.7114 37.7838 28.5093C38.0189 28.3938 38.2688 28.3071 38.5333 28.2783C38.0777 27.8162 37.4899 27.4842 36.8727 27.2676C36.52 27.1521 36.1526 27.0654 35.7705 27.0077C35.5501 27.2098 35.2708 27.3253 34.9622 27.3109C34.6536 27.3109 34.3744 27.2098 34.154 27.0221C33.478 27.1232 32.802 27.3831 32.2876 27.8162C31.788 28.235 31.494 28.7836 31.4206 29.4333C31.3912 29.6499 31.4206 29.8954 31.494 30.0975C31.5675 30.3141 31.6851 30.5162 31.8614 30.675C32.0378 30.8338 32.2582 30.9349 32.4934 30.9638C32.7579 30.9927 33.0371 30.9493 33.2869 30.8772L33.5955 30.7905L33.7572 31.0649C33.9629 31.4114 34.0364 31.8012 33.9482 32.191C33.9041 32.4221 33.8013 32.6386 33.6543 32.8408C33.5074 33.0285 33.3163 33.2017 33.0959 33.3172C32.9636 33.3894 32.8314 33.4472 32.6844 33.4761C32.7726 33.5338 32.8754 33.5771 32.9636 33.6349C33.1253 33.7071 33.2869 33.7648 33.4633 33.7937C33.4633 33.5627 33.5221 33.3317 33.6543 33.1295C33.9776 32.5953 34.5507 32.2777 35.1974 32.3499C35.4178 32.3787 35.6382 32.4509 35.844 32.5664C35.9762 32.6531 36.1085 32.7541 36.2114 32.8696C36.9755 32.6964 37.534 33.0862 37.5193 33.967C37.5193 34.0103 37.5193 34.0391 37.5193 34.0825C38.0483 34.3135 38.5774 34.7611 38.9007 35.1942L38.9742 35.3097L38.9448 35.4397C38.7684 36.0894 38.1806 36.5225 37.5928 36.8257C37.5928 36.8835 37.6075 36.9268 37.6075 36.9846C37.6221 37.9375 37.049 38.3273 36.2701 38.0819C36.1673 38.1974 36.0497 38.284 35.9174 38.3562C35.7264 38.4717 35.506 38.5439 35.2708 38.5583C34.6242 38.6161 34.0658 38.2984 33.7425 37.7642C33.6984 37.692 33.6543 37.6054 33.6249 37.5332C32.5521 37.9086 31.2001 38.6161 30.8621 39.7134C30.7593 40.0166 30.7299 40.3487 30.7887 40.6663C30.8474 40.9695 30.9944 41.2439 31.2148 41.4604C31.3912 41.6337 31.6263 41.7781 31.8614 41.8503C31.9202 41.8647 32.0378 41.8936 32.0966 41.8791L32.4493 41.8214L32.5521 42.1535C32.5962 42.2834 32.6109 42.4134 32.6109 42.5577C32.6256 42.9043 32.5374 43.2652 32.3464 43.5684C32.1407 43.9149 31.8467 44.146 31.494 44.2903C32.1994 44.9545 33.1694 45.3732 34.0952 45.5609C34.83 45.7053 35.6382 45.7342 36.3877 45.5609C37.4164 45.3154 38.2394 44.6369 38.6508 43.6984C38.3569 43.8283 38.0336 43.8861 37.7103 43.9005C37.0049 43.9149 36.3583 43.655 35.9028 43.1208C35.3884 42.5289 35.2268 41.7203 35.4031 40.9695C35.4472 40.8107 35.4913 40.6519 35.5648 40.4931C36.1526 39.2225 37.5928 38.645 38.9595 38.7893C39.9882 38.9048 40.8993 39.3669 41.4871 40.1754C41.6341 40.0166 41.7957 39.8578 41.9868 39.7278C42.3982 39.4535 42.8097 39.338 43.3241 39.3524C43.3829 39.3524 43.4416 39.3524 43.4857 39.3669C44.0442 39.4246 44.5438 39.6701 44.9112 40.0888C45.3374 40.5797 45.499 41.2005 45.499 41.8358C45.499 41.9225 45.499 42.0235 45.4843 42.1101L45.4403 42.5866L44.97 42.4422C44.7496 42.37 44.485 42.2978 44.2646 42.3845C43.9119 42.5289 43.5739 43.0775 43.3829 43.3952C43.2506 43.6406 43.133 43.9005 43.0155 44.146C42.4717 45.3876 41.9133 46.4561 40.8993 47.409C39.3856 48.8384 37.4164 49.387 35.359 49.4737C35.3002 49.4737 35.2268 49.4737 35.168 49.4737C33.8454 49.5026 32.5227 49.3149 31.2883 48.824C30.3331 48.4341 29.466 47.8855 28.7313 47.178C28.2316 46.7015 27.776 46.1384 27.4233 45.5465C27.2617 45.2866 27.0853 44.9545 26.9678 44.6369C26.6445 44.6802 26.2918 44.6802 25.9685 44.5935C25.4982 44.478 25.1161 44.2037 24.8516 43.7994C24.7046 43.5684 24.6165 43.3085 24.5577 43.0486L24.4989 42.7166L24.8222 42.6011C25.6452 42.3123 25.7333 41.7636 25.8656 41.0128C25.895 40.8973 25.9097 40.7674 25.9391 40.6519C26.1742 39.5401 26.4828 38.4573 27.1441 37.5043C27.8348 36.5225 28.7607 35.8728 29.8481 35.4108C29.3485 35.0209 28.9076 34.5445 28.599 33.9958C28.2316 34.0969 27.8348 34.1113 27.4674 34.0391C26.6004 33.8803 26.0419 33.2595 25.6893 32.4942L25.4835 32.0467L25.9832 31.96C26.2771 31.9167 26.5563 31.8012 26.762 31.5846C27.2323 31.1226 27.394 30.213 27.5409 29.6066C27.7907 28.5237 28.0406 27.4986 28.7019 26.5745C29.466 25.5061 30.5682 24.8708 31.8027 24.4954C31.4794 24.4521 31.156 24.351 30.9062 24.1345C30.6564 23.9035 30.5241 23.5714 30.5388 23.2249C30.5535 22.9505 30.6417 22.6762 30.8034 22.4452C31.0238 22.1276 31.3471 21.9399 31.7292 21.8677C31.9349 21.8243 32.1554 21.8243 32.3611 21.8532C32.655 21.3768 33.1694 21.2613 33.7131 21.3912C33.9482 21.0447 34.3009 20.7704 34.683 20.5971L34.8006 20.5249L34.9034 20.5393C35.4913 20.626 35.844 20.9581 36.1232 21.4201C36.711 21.2468 37.2695 21.3623 37.5781 21.8821C37.7838 21.8532 38.0042 21.8677 38.21 21.911C38.5921 21.9832 38.9154 22.1853 39.1211 22.5029C39.2828 22.734 39.3709 23.0083 39.3856 23.2971C39.4003 23.6291 39.2828 23.9757 39.0182 24.2067C38.8566 24.351 38.6215 24.4521 38.3716 24.4954Z" fill="white"/>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            img() {
                try {
                    return require('~/assets/' + 'loading.png')
                } catch(e) {
                  console.error(e)
                  return false
                }
            }
        }
    }
</script>

<style lang="less">
    .loading-component {
        width: 100vw;
        height: 100vh;
        background-color: #2F1F4C;
        position: fixed;
        left: 0px;
        top: 0px;
        z-index: 15;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loading-component__logo {
        width: 70px;
        height: 70px;
        position: relative;
        animation: rotating 2s linear infinite;
    }

    .loading-component__logo img {
        width: 100%;
        height: 100%;
    }

    .loading-component__svg {
        position: absolute;
    }



    @keyframes rotating {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .loading-component__points {
        display: flex;
        align-items: center;
        position: absolute;
        margin-top: 50px;
        overflow: hidden;
        width: 73px;
        height: 30px;
    }

    .loading-component__points-wrapper {
        display: flex;
        align-items: center;
        animation: loading-points 1s linear infinite;
    }

    .loading-component__point {
        height: 5px;
        width: 5px;
        background-color: grey;
        border-radius: 100%;
        margin-left: 2px;
        margin-right: 2px;
    }

    .point-1 {
        height: 11px;
        width: 11px;
        background-color: white;
    }

    .point-2 {
        height: 9px;
        width: 9px;
        background-color: white;
    }

    .point-3 {
        height: 7px;
        width: 7px;
        background-color: white;
    }


    @keyframes loading-points {
        0% {
            margin-left: -130px;
        } 

        100% {
            margin-left: 10px;
        }
    }
</style>